import { Field } from 'types'

import {
    createActionField,
    createField,
    withGroupByPlaceholder,
} from './createField'
import { FieldCreatorOptions } from './localTypes'

export function query<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const key = 'query'
    const displayName = 'Search Term'
    return withGroupByPlaceholder(
        createField({
            ...options,
            id: key,
            name: displayName,
            shortName: displayName,
            minWidth: 100,
            dataIndex: options.dataIndex ?? [key],
            width: 200,
            sorter: options.sorter ?? false,
        }),
        {
            id: key,
            slug: 'search-term',
            displayName,
            definition: 'Displays the search query',
            supportsTotal: true,
        }
    )
}

export function addSearchTerm<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const dataIndex = options.dataIndex ?? ['keyword', 'id']
    return createActionField({
        ...options,
        id: 'add_search_term_v2', // increment version because column width changed and column is fixed
        isResizeable: false,
        dataIndex,
        minWidth: 290,
        sorter: false,
        fixed: options.fixed ?? 'right',
        align: 'center',
    })
}
